// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles_loading_2OeGC-FFWk63LaLgjQK4Sl","spinner":"styles_spinner_3DxFV3STiXuXC7BRBcaP4R","text":"styles_text_209SlkXARWng5qGs7hmEJh"};